<app-oee-modal
    title="Archive Event"
    subtitle="Remove this event from OEE calculations"
    [contextName]="data.eventType"
    icon="archive"
    [useMaterialIcon]="true"
    iconColor="yellow"
    tint="amber">

    <!-- Modal Content -->
    <ng-container modal-content>
        <p class="mb-3">
            Are you sure you want to archive this <strong>{{ data.eventType }}</strong> event?
        </p>

        <!-- Warning for running jobes -->
        @if (data.hasRunningBatches) {
            <div class="alert alert-warning d-flex align-items-center mb-3">
                <i class="fa fa-exclamation-triangle me-2"></i>
                <span>This event has running jobes that will be cancelled.</span>
            </div>
        }

        <!-- Warning for multi-equipment events -->
        @if (data.linkedEquipmentNames?.length) {
            <div class="alert alert-info d-flex align-items-start mb-3">
                <i class="fa fa-link me-2 mt-1"></i>
                <div>
                    <strong>Multi-Equipment Event</strong>
                    <p class="mb-1 mt-1">This event is linked to {{ data.linkedEquipmentNames.length }} additional equipment.
                        Archiving will remove it from OEE calculations for all linked equipment:</p>
                    <ul class="mb-0 ps-3">
                        @for (name of data.linkedEquipmentNames; track name) {
                            <li>{{ name }}</li>
                        }
                    </ul>
                </div>
            </div>
        }

        <div class="info-box mb-3">
            <i class="fa fa-info-circle text-primary"></i>
            <span>Archived events are excluded from OEE calculations but can be restored later.</span>
        </div>

        <!-- Reason Selection -->
        <div class="reason-section">
            <label class="form-label fw-bold">Why are you archiving this event?</label>
            <div class="reason-options">
                @for (reason of reasonOptions; track reason) {
                    <button type="button" class="reason-chip"
                        [class.selected]="selectedReason === reason" (click)="selectReason(reason)">
                        {{ reason }}
                    </button>
                }
            </div>

            <!-- Custom reason input -->
            @if (showCustomInput) {
                <div class="custom-reason-input mt-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Please specify reason</mat-label>
                        <input matInput [(ngModel)]="customReason" placeholder="Enter reason for archiving..." maxlength="200">
                        <mat-hint align="end">{{ customReason.length }}/200</mat-hint>
                    </mat-form-field>
                </div>
            }
        </div>
    </ng-container>

    <!-- Modal Actions -->
    <ng-container modal-actions>
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="warn" (click)="onConfirm()" [disabled]="!isValid()">
            <mat-icon>archive</mat-icon>
            Archive Event
        </button>
    </ng-container>

</app-oee-modal>
